<template>
  <div class="flex flex-column gap-4">
    <!-- Cambiar contraseña -->
    <div class="flex flex-column gap-2">
      <div class="font-semibold text-sm">Cambiar contraseña</div>
      <div class="flex flex-column gap-1">
        <label class="text-sm">Contraseña actual</label>
        <InputText v-model="pwd.current" type="password" placeholder="Contraseña actual" />
      </div>
      <div class="flex flex-column gap-1">
        <label class="text-sm">Nueva contraseña</label>
        <InputText v-model="pwd.next" type="password" placeholder="Mínimo 6 caracteres" />
      </div>
      <div class="flex flex-column gap-1">
        <label class="text-sm">Confirmar nueva contraseña</label>
        <InputText v-model="pwd.confirm" type="password" placeholder="Repetí la nueva contraseña" />
      </div>
      <div v-if="pwd.error" class="text-red-500 text-sm">{{ pwd.error }}</div>
      <div v-if="pwd.success" class="text-green-600 text-sm">Contraseña actualizada</div>
      <div class="flex justify-content-end">
        <Button label="Actualizar contraseña" size="small" :loading="pwd.saving" @click="changePassword" />
      </div>
    </div>

    <div class="border-top-1 surface-border" />

    <!-- Cambiar usuario -->
    <div class="flex flex-column gap-2">
      <div class="font-semibold text-sm">Cambiar usuario</div>
      <div class="text-sm text-color-secondary">Usuario actual: {{ userStore.email }}</div>
      <div class="flex flex-column gap-1">
        <label class="text-sm">Nuevo usuario</label>
        <InputText v-model="mail.next" placeholder="nuevo usuario" />
      </div>
      <div class="flex flex-column gap-1">
        <label class="text-sm">Contraseña actual</label>
        <InputText v-model="mail.password" type="password" placeholder="Confirmá con tu contraseña" />
      </div>
      <div v-if="mail.error" class="text-red-500 text-sm">{{ mail.error }}</div>
      <div v-if="mail.success" class="text-green-600 text-sm">Usuario actualizado</div>
      <div class="flex justify-content-end">
        <Button label="Actualizar usuario" size="small" :loading="mail.saving" @click="changeEmail" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive } from 'vue'
import { useApi } from '@/composables/useApi'
import { useUserStore } from '@/store/useUserStore'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'

const api = useApi()
const userStore = useUserStore()

const pwd = reactive({ current: '', next: '', confirm: '', saving: false, error: null, success: false })
const mail = reactive({ next: '', password: '', saving: false, error: null, success: false })

const changePassword = async () => {
  pwd.error = null
  pwd.success = false
  if (!pwd.current || !pwd.next) { pwd.error = 'Completá la contraseña actual y la nueva'; return }
  if (pwd.next.length < 6) { pwd.error = 'La nueva contraseña debe tener al menos 6 caracteres'; return }
  if (pwd.next !== pwd.confirm) { pwd.error = 'Las contraseñas no coinciden'; return }
  pwd.saving = true
  try {
    const result = await api.put('/api/auth/password', { currentPassword: pwd.current, newPassword: pwd.next })
    if (result.error) { pwd.error = result.error; return }
    pwd.current = ''
    pwd.next = ''
    pwd.confirm = ''
    pwd.success = true
  } finally {
    pwd.saving = false
  }
}

const changeEmail = async () => {
  mail.error = null
  mail.success = false
  if (!mail.next || !mail.password) { mail.error = 'Completá el nuevo usuario y tu contraseña'; return }
  mail.saving = true
  try {
    const result = await api.put('/api/auth/email', { newEmail: mail.next, currentPassword: mail.password })
    if (result.error) { mail.error = result.error; return }
    userStore.updateAccount({ email: result.email, token: result.token })
    mail.next = ''
    mail.password = ''
    mail.success = true
  } finally {
    mail.saving = false
  }
}
</script>
